import { createToastService } from '@multivac-se/s2-components';

const toastService = createToastService();

export function useToast() {
  return toastService;
}
